import * as React from "react";
import { Button } from "antd";
import { t } from "i18next";
import { ModalVertFixed } from "src/components/ModalVertFixed";
import { PropsUploaderDragger, UploaderDragger } from "./UploaderDragger";
import { UploadInfo } from "../PlmUploader";
import styles from "./UploaderModal.module.less";

type PropsUploaderModal = PropsUploaderDragger & {
  open?: boolean;
  onClose?: () => void;
};

export const UploaderModal: React.FC<PropsUploaderModal> = (props) => {
  const { open, isImage, onClose, maxSize, uploadProps, ...draggerProps } =
    props;
  const { fileList = [], accept, maxCount = 1 } = uploadProps;
  return (
    <ModalVertFixed
      height="80vh"
      open={open}
      title={isImage ? t("Image modification") : t("File modification")}
      className={styles.imageUploadModal}
      closable={false}
      maskClosable={false}
      footer={
        <div className={styles.modalFooter}>
          <Button
            className={styles.finishButton}
            type="primary"
            onClick={onClose}
          >
            {t("Finish")}
          </Button>
        </div>
      }
    >
      {fileList?.length >= maxCount && (
        <UploadInfo maxCount={maxCount} accept={accept} maxSize={maxSize} />
      )}
      <UploaderDragger
        maxSize={maxSize}
        uploadProps={uploadProps}
        isImage={isImage}
        {...draggerProps}
      />
    </ModalVertFixed>
  );
};
